import React from "react";
import { Alert } from "@mui/material";

const SignupAlert = ({ error, success, onSuccessClose }) => (
  <>
    {error && (
      <Alert severity="error" sx={{ mt: 1.5 }}>
        {error}
      </Alert>
    )}
    {success && (
      <Alert severity="success" sx={{ mt: 1.5 }} onClose={onSuccessClose}>
        {success}
      </Alert>
    )}
  </>
);

export default SignupAlert;
